import {
    FETCH_QUATERLY_REPORT,
    QUATERLY_REPORT_ERROR,
    FETCH_QUATERLY_REPORT_LIST,
    CREATE_QUATERLY_REPORT,
    UPDATE_QUATERLY_REPORT,
    UPDATE_QUATERLY_PICTURE,
    DELETE_QUATERLY_REPORT,
    EXPORT_QUATERLY_REPORT,
    SET_INITIAL_STATE_QUATERLY_REPORT
  } from '../actions/types';


  const INITIAL_STATE = {
    quaterlyReport: {},
    list: {},
    message: '',
    error: ''
  };


  export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_QUATERLY_REPORT:
            return { ...state,
              quaterlyReport: action.payload.quaterlyReport,
              message: action.payload.message,
            };
        case FETCH_QUATERLY_REPORT_LIST:
            return { ...state,
              list: action.payload.list,
              message: '',
              error: ''
            };
        case CREATE_QUATERLY_REPORT:
            return { ...state,
              quaterlyReport: action.payload.quaterlyReport,
              message: action.payload.message,
              error: ''
            };
        case UPDATE_QUATERLY_REPORT:
            return { ...state,
              quaterlyReport: action.payload.quaterlyReport,
              message: action.payload.message,
              error: ''
            };
        case EXPORT_QUATERLY_REPORT:
          return { ...state, export: action.payload, message: '', error: '' };
        case DELETE_QUATERLY_REPORT:
            return { ...state,
              message: action.payload.message,
              error: ''
            };
        case UPDATE_QUATERLY_PICTURE:
          const quaterlyReport = Object.assign({}, action.payload.quaterlyReport);
          return { ...state,
            quaterlyReport: quaterlyReport,
            message: action.payload.message,
            error: ''
          };
        case QUATERLY_REPORT_ERROR:
            return { ...state,
              error: action.payload
            };
        case SET_INITIAL_STATE_QUATERLY_REPORT:
            return INITIAL_STATE;
        default:
            return { ...state
            }
    }

}